import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbModule, NgbDatepickerI18n, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { PopUpComponent } from './shared/components/pop-up/pop-up.component';
import { SosAlertComponent } from './shared/components/sos-alert/sos-alert.component';
import { EbsAlertComponent } from './shared/components/ebs-alert/ebs-alert.component';
import { ShowAlertInfoComponent } from './shared/components/show-alert-info/show-alert-info.component';
import { ShowAlertInfoIntegrateComponent } from './shared/components/show-alert-info-integrate/show-alert-info-integrate.component';
import { ShowEbsalertInfoComponent } from './shared/components/show-ebsalert-info/show-ebsalert-info.component';
import { ShowMapInfoComponent } from './shared/components/show-map-info/show-map-info.component';
import { DatePipe } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask';
import { TextMaskModule } from 'angular2-text-mask';
import 'hammerjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FormModalComponent } from './shared/components/form-modal/form-modal.component';
import { FormQuestionnaireComponent } from './shared/components/form-questionnaire/form-questionnaire.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppComponent } from './app.component';
import {
    ApiService,
    AuthGuard,
    FooterComponent,
    HeaderComponent,
    JwtService,
    SharedModule,
    TagsService,
    UserService,
    ModalService,
    ValidateService,
    DateService,
    CaregiverService,
    PatientService,
    NotificationService,
    SocketService,
    ReachService,
    HttpTokenInterceptor,
} from './shared';
import { CaretakerService } from './shared/services/caretaker.service';
import {I18nDatePicker} from './shared/components/date-picker/date-picker.component';
import {ToastModule} from 'primeng/toast';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {MessageService} from 'primeng/api';
import {ChartsModule} from 'ng2-charts';
import { VoipWidgetModule } from './voip/voip-widget.module';
const rootRouting: ModuleWithProviders<any> = RouterModule.forRoot([]);

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        HeaderComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        SharedModule,
        ChartsModule,
        rootRouting,
        SharedModule,
        MatInputModule,
        MatButtonModule,
        ButtonModule,
        TableModule,
        ToastModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatChipsModule,
        MatDatepickerModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        BrowserAnimationsModule,
        MatExpansionModule,
        MatCheckboxModule,
        NgbDropdownModule,
        NgxMaskModule.forRoot(),
        TextMaskModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        NgbModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyAHYXRRNQFdClY3I_uHg19moSGwWp8YFEU',
            libraries: ['places'],
        }),
        VoipWidgetModule,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'pl-PL' },
        { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
        { provide: NgbDatepickerI18n, useClass: I18nDatePicker },
        ApiService,
        AuthGuard,
        JwtService,
        TagsService,
        UserService,
        ModalService,
        ValidateService,
        DateService,
        CaregiverService,
        PatientService,
        NotificationService,
        SocketService,
        ReachService,
        CaretakerService,
        MessageService,
        DatePipe,
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
